import BaseAPI from '@/apis/base/baseApi'
import { FormMultiPart } from '../base/httpclient'
import store from '@/stores/store.js'
import { ModuleContext } from '@/stores/moduleConst'
import { checkIsUploadAnonymous } from '@/components/utils/upload'

class FileAPI extends BaseAPI {
  apiName = 'File';
  controllerName = 'File';

  /**
   * lấy link gọi download file
   * @param {*} type : File gì
   * @param {*} file : tên file server
   * @param {*} name : Tên file lưu về
   * @param {*} tenant :Dữ liệu công ty nào
   */
  getDownloadLink (type, file, name, tenant) {
    const url = [this.getAPIUrl(), 'download', type + '', tenant, file, name]

    return url.filter(item => item).join('/')
  }

  /**
   * lấy link gọi file
   * trả về content-type theo type - không force downoad
   * @param {*} type : File gì
   * @param {*} file : tên file server
   * @param {*} name : Tên file lưu về
   */
  getFileLink (type, file, name, tenantId) {
    const url = [this.getAPIUrl(), type + '', file, name, tenantId]

    return url.filter(item => item).join('/')
  }

  /**
   * @author PVThang
   * @description upload list file
   * @param {FormData} formData
   * @returns
   */
  uploadFiles (formData) {
    const me = this
    const config = {
      headers: {
        'Content-Type': FormMultiPart,
      },
      data: formData,
      url: me.getAPIUrl() + '/multi',
    }

    return this.postAsync(config, false)
  }

  /**
   * @author PVThang
   * @description copy list file từ temp => real
   * @param {*} files
   * @returns
   */
  async copyFiles (files) {
    if (!files?.length) {
      return Promise.resolve([])
    }
    const me = this
    const data = files.map((file) => {
      return {
        FileID: file.FileID,
        FileName: `${file.FileID}${file.FileExtension}`,
        StorageType: file.StorageType,
      }
    })
    const pathItems = ['copy', 'multi']
    const isAnonymous = files.every(file => checkIsUploadAnonymous(file.StorageType))
    if (isAnonymous) {
      pathItems.unshift('anonymous')
    }
    const config = {
      data: data,
      url: me.getAPIUrl(...pathItems),
    }
    const res = await me.postAsync(config, false)
    if (res?.length > 0) {
      res?.forEach(fileResult => {
        if (fileResult?.IsSuccess) {
          const file = files?.find(fileParam => fileParam.FileID === fileResult.FileID)
          if (file) {
            delete file.IsTemp
          }
        }
      })
    }
    return res
  }

  /**
   * @author PVThang
   * @description download file
   * @param {*} payload
   * @returns
   */
  // Dùng hàm download trong commonFn
  // async downloadFile (payload) {
  //   const me = this
  //   const config = {
  //     url: me.getDownloadLink(
  //       payload.type,
  //       payload.file,
  //       payload.fileName,
  //       payload.tenant
  //     ),
  //   }

  //   return await me.getAsync(config, false)
  // }

  /**
   * lấy link gọi file
   * trả về content-type theo type - không force downoad
   * @param {*} type : File gì
   * @param {*} name : tên file server
   * @param {*} width : độ rộng ảnh
   * @param {*} height : chiều dài ảnh
   * @param {*} quantity : độ phân giải
   */
  getImageLink (type, name, width, height, tenantID, quantity) {
    const url = [this.getAPIUrl(), 'image', type]
    if (name) {
      url.push(name)
      if (width) {
        url.push(width)
      }
      if (height || height === 0) {
        url.push(height)
      }
    }
    if (!tenantID) {
      tenantID = store.state[ModuleContext]?.Context?.TenantID
    }
    if (tenantID) {
      url.push(tenantID)
    }
    if (quantity) {
      url.push(quantity)
    }

    return url.join('/')
  }

  /**
   * Lấy url preview file
   * @param {*} config
   */
  getFileUrl (config) {
    const me = this
    config ??= {}

    return `${me.getAPIUrl()}/${config.StorageType}/${config.FileID}/${encodeURI(config.FileName)}/${config.OwnerId}`
  }

  /**
   * Lấy url preview file
   * @param {*} config
   */
  getPreviewUrl (config) {
    const me = this
    config ??= {}

    return `${me.getAPIUrl()}/image/${config.StorageType}/${encodeURI(config.FileName)}/${config.OwnerId}`
  }
}

export default new FileAPI()
